import React, { useContext, useEffect, useState } from "react";
import {
    ChildrenProps,
    SetBooleanType,
} from "../customTypes/valueTypes";
import Cookies from "js-cookie";
import { IFinalTechnicalOutcomeListObj } from "../Models/applicationModels";
import { getApplicationListRespModel } from "../Models/tableDetailsModel";

const DashboardInfoContext = React.createContext<DashboardInfoPayload | null>(null);

export interface DashboardInfoPayload {
    isSidebarCollapsed: boolean;
    setIsSidebarCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
    currentActiveEnvironment: string;
    setCurrentActiveEnvironment: React.Dispatch<React.SetStateAction<string>>;
    finalTechnicalOutecomeList: IFinalTechnicalOutcomeListObj[];
    setFinalTechnicalOutcomeList: React.Dispatch<React.SetStateAction<IFinalTechnicalOutcomeListObj[]>>;
    applicationListRows: getApplicationListRespModel[] | null
    setApplicationListRows: React.Dispatch<React.SetStateAction<getApplicationListRespModel[] | null>>;
    applicantFullName: String | null;
    setApplicantFullName: React.Dispatch<React.SetStateAction<String | null>>;
    agentFullName: string | null;
    setAgentFullName: React.Dispatch<React.SetStateAction<string | null>>;
}

const DashboardInfoProvider = ({ children }: ChildrenProps) => {

    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState<boolean>(false);
    const [currentActiveEnvironment, setCurrentActiveEnvironment] = useState<string>(Cookies.get("selectedBaseUrl") ?? "Staging")
    const [finalTechnicalOutecomeList, setFinalTechnicalOutcomeList] = useState<IFinalTechnicalOutcomeListObj[]>([]);
    const [applicationListRows, setApplicationListRows] = useState<getApplicationListRespModel[] | null>(null);
    const [applicantFullName, setApplicantFullName] = useState<String | null>(null);
    const [agentFullName, setAgentFullName] = useState<string | null>(null);

    const payload: DashboardInfoPayload = {
        isSidebarCollapsed,
        setIsSidebarCollapsed,
        currentActiveEnvironment,
        setCurrentActiveEnvironment,
        finalTechnicalOutecomeList,
        setFinalTechnicalOutcomeList,
        applicationListRows,
        setApplicationListRows,
        applicantFullName,
        setApplicantFullName,
        agentFullName,
        setAgentFullName,
    };

    return (
        <DashboardInfoContext.Provider value={payload}>
            {children}
        </DashboardInfoContext.Provider>
    )
}

const useDashboardInfo = (): DashboardInfoPayload => {
    const context = useContext(DashboardInfoContext);
    if (!context) {
        throw new Error("useDashboardInfo must be used within a DashboardInfoProvider");
    }
    return context;
};

export { DashboardInfoContext, DashboardInfoProvider, useDashboardInfo };
